import iRazTestnet from './testnet/iRaz.sol/iRaz.json';
import iRazMainnet from './mainnet/iRaz.sol/iRaz.json';

let iRaz = iRazTestnet;
if(process.env.REACT_APP_NODE_ENV === "production"){
    iRaz = iRazMainnet;
}

export default iRaz;